import clsx from "clsx";
import { graphql, navigate } from "gatsby";
import AliceCarousel from 'react-alice-carousel';
import Img from "gatsby-image";
import 'react-alice-carousel/lib/alice-carousel.css';
// import { SlideShow } from "../components/Slider";

// import { kebabCase } from "lodash";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import Helmet from "react-helmet";

import {
  Avatar,
  Chip,
  Container,
  ListItem,
  ListItemText,
  Typography,
  Hidden,
  ListItemIcon,
} from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  ContactSupport as ContactSupportIcon
} from "@material-ui/icons";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { isWidthUp } from "@material-ui/core/withWidth";
import Content, { HTMLContent } from "../components/Content";
import Layout from "../components/Layout";
import Map from "../components/Map";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mediaLinks: {
      marginRight: "15px !important",
      background: "dimgrey !important",
      borderRadius: "10px !important",
      border: "1px solid black !important",
      padding: "4px !important",
      color: "#EEE !important",
      justifyContent: 'flex-start !important',
      width: "auto !important",
      "& .MuiListItemText-root": {
        flex: 'none',
      },
      '& .MuiListItemText-primary': {
        display: 'inline',
      }
    },
    root: {
      display: "grid",
      gridArea: "content",
    },
    header: {
      // [theme.breakpoints.down("sm")]: {
      //   height: `auto`,
      // },
      // [theme.breakpoints.up("sm")]: {
      //   height: `calc(100vh - 64px - 50px)`,
      // },
      // minHeight: 400,
      position: "relative",
      overflow: "hidden",
      width: "100vw",
      margin: "10px auto",
      "& .alice-carousel__wrapper": {
        paddingLeft: "27% !important",
        paddingRight: "27% !important",
        [theme.breakpoints.down("sm")]: {
          paddingLeft: "16px !important",
          paddingRight: "10px !important"
        }
      },
      "& .alice-carousel__prev-btn-item": {
        position: "absolute",
        width: 40,
        height: 40,
        top: "45%",
        left: "30%",
        color: "black",
        background: "lightgrey",
        padding: "0px 14px",
        fontSize: 25,
        borderRadius: "50%",
        [theme.breakpoints.down("sm")]: {
          left: 30,
          top: "38%"
        }
      },
      "& .alice-carousel__next-btn-item": {
        position: "absolute",
        width: 40,
        height: 40,
        top: "45%",
        right: "30%",
        color: "black",
        background: "lightgrey",
        padding: "0px 14px",
        fontSize: 25,
        borderRadius: "50%",
        [theme.breakpoints.down("sm")]: {
          right: 30,
          top: "38%"
        }
      },
      "& .alice-carousel__prev-btn-item:hover": {
        background: "grey",
        color: "black"
      },
      "& .alice-carousel__next-btn-item:hover": {
        background: "grey",
        color: "black"
      },
      "& .alice-carousel__dots-item": {
        width: 12,
        height: 12
      },
      "& .alice-carousel__dots-item:hover, .alice-carousel__dots-item.__active": {
        backgroundColor: "#333 !important"
      },
    },
    heading: {
      marginBottom: theme.spacing(4),
      textAlign: "center",
      [theme.breakpoints.up("sm")]: {
        //   display: "none"
        gridColumn: `1/4`,
        marginBottom: theme.spacing(8),
        marginTop: theme.spacing(4),
      },
    },
    article: {
      [theme.breakpoints.up("sm")]: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
      },
      gap: `${theme.spacing(8)}px`,
      marginBottom: theme.spacing(6),
      marginTop: theme.spacing(1),
    },
    map: {
      [theme.breakpoints.down("sm")]: {
        height: "300px",
        marginTop: theme.spacing(3),
      },
      [theme.breakpoints.up("sm")]: {
        height: "auto"
      }
    },
    registerInterest: {
      width: "100%",
      maxWidth: "200px",
      textAlign: "center",
      height: "42px",
      flex: "0 0 100%",
    },
    chips: {
      display: "grid",
      marginTop: 10,
      gap: `${theme.spacing(1)}px`,
      justifyContent: "start",
      justifyItems: "start",
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: `repeat(2, 1fr)`,
      },
      [theme.breakpoints.up("sm")]: {
        // gridTemplateColumns: `repeat(4, 1fr)`
        gridAutoFlow: "column",
      },
    },
    images: {
      display: "grid",
      // gridTemplateColumns: "1fr 1fr",
      gridTemplateColumns: `repeat(auto-fill, minmax(25vw, 1fr))`,
      gridAutoFlow: "row dense",
      // gridAutoRows: `minmax(25vw, auto)`,
      "& > *": {
        // flex: "1 1 200px",
        "&:nth-of-type(3)": { gridColumnEnd: "span 2", gridRowEnd: "span 2" },
        "&:nth-of-type(1n+10)": {
          display: "none",
        },
      },
    },
    carousel: {
      margin: 16,
      [theme.breakpoints.down("sm")]: {
        margin: 4
      }
    },
    outline: {
      border: "1px solid black",
      color: "black !important"
    },
    buttonsWrapper: {
      display: "flex",
      justifyContent: "flex-start",
    },
    backBtn: {
      width: 155,
      marginLeft: 20,
      cursor: "pointer",
      "& span": {
        position: "absolute",
        marginTop: "1px",
        marginLeft: "5px"
      }
    }
  })
);

export const PropertyPostTemplate = ({
  content,
  contentComponent,
  title,
  helmet,
  images,
  frontmatter,
  filterOptions
}): ReactElement => {
  const PostContent = contentComponent || Content;
  const classes = useStyles();
  console.log(frontmatter)
  const markers = [
    {
      geometry: {
        coordinates: [frontmatter.longitude, frontmatter.latitude],
      },
      properties: {
        id: frontmatter.id,
        title: frontmatter.title,
        price:
          frontmatter.poa ? 'P.O.A' :
            frontmatter.pricetext ?
              frontmatter.pricetext + " " +
              (frontmatter.rentalperiod < 2
                ? new Intl.NumberFormat("en-UK", {
                  style: "currency",
                  useGrouping: true,
                  maximumSignificantDigits: 21,
                  currency: "GBP",
                }).format(frontmatter.price)
                : new Intl.NumberFormat("en-UK", {
                  style: "currency",
                  useGrouping: true,
                  maximumSignificantDigits: 21,
                  currency: "GBP",
                }).format(
                  frontmatter.rentalperiod === 4
                    ? Math.round(frontmatter.price)
                    : Math.round(frontmatter.price * 52 / 12)
                ) +
                "pcm" +
                "" +
                new Intl.NumberFormat("en-UK", {
                  style: "currency",
                  useGrouping: true,
                  maximumSignificantDigits: 21,
                  currency: "GBP",
                }).format(
                  frontmatter.rentalperiod === 4
                    ? Math.round(frontmatter.price * 12 / 52)
                    : Math.round(frontmatter.price)
                ) +
                "pw")
              : frontmatter.rentalperiod < 2
                ? new Intl.NumberFormat("en-UK", {
                  style: "currency",
                  useGrouping: true,
                  maximumSignificantDigits: 21,
                  currency: "GBP",
                }).format(frontmatter.price)
                : new Intl.NumberFormat("en-UK", {
                  style: "currency",
                  useGrouping: true,
                  maximumSignificantDigits: 21,
                  currency: "GBP",
                }).format(
                  frontmatter.rentalperiod === 4
                    ? Math.round(frontmatter.price)
                    : Math.round(frontmatter.price * 52 / 12)
                ) +
                "pcm" +
                " " +
                new Intl.NumberFormat("en-UK", {
                  style: "currency",
                  useGrouping: true,
                  maximumSignificantDigits: 21,
                  currency: "GBP",
                }).format(
                  frontmatter.rentalperiod === 4
                    ? Math.round(frontmatter.price * 12 / 52)
                    : Math.round(frontmatter.price)
                ) +
                "pw",
        image: frontmatter.featuredimage?.childImageSharp,
      },
    },
  ];

  const convertedPrice =
    (frontmatter.rentalperiod < 2
      ? new Intl.NumberFormat("en-UK", {
        style: "currency",
        useGrouping: true,
        maximumSignificantDigits: 21,
        currency: "GBP",
      }).format(frontmatter.price)
      : new Intl.NumberFormat("en-UK", {
        style: "currency",
        useGrouping: true,
        maximumSignificantDigits: 21,
        currency: "GBP",
      }).format(
        frontmatter.rentalperiod === 4
          ? Math.round(frontmatter.price)
          : Math.round(frontmatter.price * 52 / 12)
      ) +
      "pcm" +
      " " +
      new Intl.NumberFormat("en-UK", {
        style: "currency",
        useGrouping: true,
        maximumSignificantDigits: 21,
        currency: "GBP",
      }).format(
        frontmatter.rentalperiod === 4
          ? Math.round(frontmatter.price * 12 / 52)
          : Math.round(frontmatter.price)
      ) +
      "pw")

  const handleDragStart = (e) => { e.preventDefault() }

  const bgImages = images?.map((img) =>
    <div
      className={classes.carousel}
      key={img?.id}
      onDragStart={handleDragStart}
    >
      <Img
        fluid={img?.childImageSharp.fluid}
      />
    </div>
  );
  if (frontmatter.sold !== undefined && frontmatter.dateSTC !== "") {
    console.log(frontmatter.dateSTC)
  }

  return (
    <main className={clsx(classes.root)}>
      {helmet || ""}
      <header className={classes.header}>
        <AliceCarousel
          mouseTracking
          items={bgImages}
          animationDuration={800}
          infinite
        />

        <div className={classes.overlay}>
          <Container className={classes.overlayContainer} fixed>
            <Typography
              className={clsx("hide-text")}
              component="h2"
              variant="h6"
            >
              {title}
            </Typography>
          </Container>
        </div>
        <div className={classes.backBtn} onClick={() => {
          navigate('/result', {
            state: { filterOptions }
          })
        }}>
          <ArrowBackIcon /> <span>Back to Search</span>
        </div>
      </header>
      {/* {images && images.map((image, key) => <div key={key}>img</div>)} */}
      <Container
        component="article"
        fluid="fluid"
        className={clsx(classes.segment, classes.article)}
      >
        <section className={clsx(classes.segment)} style={{ background: "rgb(250, 250, 250)", zIndex: 10, position: "relative" }}>
          <Typography
            className={clsx(classes.heading)}
            component="h2"
            variant="h2"
          >
            {title}
          </Typography>

          <Typography
            className={clsx(classes.heading)}
            component="h3"
            variant="h3"
          >
            {frontmatter.poa ? "P.O.A" :
              (frontmatter.pricetext ? `${frontmatter.pricetext} ${convertedPrice}` : convertedPrice)}
            {frontmatter.sold == 2 && <p style={{ fontSize: 16, fontWeight: 'bold' }}>Sold/STC</p>}
            {frontmatter.UO_LA && <p style={{ fontSize: 16, fontWeight: 'bold' }}>Let/Let Agreed</p>}
          </Typography>
          <div className={classes.buttonsWrapper}>
            <div>
              {(frontmatter.floorPlan && frontmatter.floorPlan !== 'undefined&width=1920') && (
                <ListItem className={classes.mediaLinks} style={{ marginRight: 15 }} button component={"a"}
                  href={frontmatter.floorPlan}
                  onClick={
                    (e) => {
                      e.preventDefault()
                      window.open(`${frontmatter.floorPlan}`, 'newwindow', 'width=800,height=600')
                      return false
                    }}
                >
                  <ListItemText primary="Floor Plan" />
                </ListItem>
              )}
              {(frontmatter.virturaltour && frontmatter.virturaltour !== 'undefined') && (
                <ListItem className={classes.mediaLinks} button component={"a"}
                  href={frontmatter.virturaltour}
                  onClick={
                    (e) => {
                      e.preventDefault()
                      window.open(`${frontmatter.virturaltour}`, 'newwindow', 'width=800,height=600')
                      return false
                    }}
                >
                  <ListItemText primary="Virtual Tour" />
                </ListItem>
              )}
            </div>
            <ListItem
              button
              component="a"
              href={`/register-interest?id=${frontmatter.id}&name=${frontmatter.title}&price=${frontmatter.poa ? "P.O.A" :
                (frontmatter.pricetext ? `${frontmatter.pricetext} ${convertedPrice}` : convertedPrice)}`}
              key="register-interest"
              style={{ backgroundColor: "rgb(220, 0, 78)", color: "white" }}
              className={classes.registerInterest}
            >
              <Hidden mdUp>
                <ListItemIcon>
                  <ContactSupportIcon />
                </ListItemIcon>
              </Hidden>
              <ListItemText
                primary="Register Your Interest"
              />
            </ListItem>
          </div>


          <PostContent content={content} />
          <div className={clsx(classes.chips)}>
            {frontmatter.bedrooms > 0 && (
              <Chip
                className={classes.outline}
                avatar={<Avatar className={classes.outline}>{frontmatter.bedrooms}</Avatar>}
                label="Bedrooms"
              />
            )}
            {frontmatter.bathrooms > 0 && (
              <Chip className={classes.outline}
                avatar={<Avatar className={classes.outline}>{frontmatter.bathrooms}</Avatar>}
                label="Bathrooms"
              />
            )}
            {frontmatter.gardens > 0 && (
              <Chip className={classes.outline}
                avatar={<Avatar className={classes.outline}>{frontmatter.gardens}</Avatar>}
                label="Gardens"
              />
            )}
            {frontmatter.garages > 0 && (
              <Chip className={classes.outline}
                avatar={<Avatar className={classes.outline}>{frontmatter.garages}</Avatar>}
                label="Garages"
              />
            )}
            {frontmatter.parkingSpaces > 0 && (
              <Chip className={classes.outline}
                avatar={<Avatar className={classes.outline}>{frontmatter.parkingSpaces}</Avatar>}
                label="Parking Spaces"
              />
            )}
            {frontmatter.receptions > 0 && (
              <Chip className={classes.outline}
                avatar={<Avatar className={classes.outline}>{frontmatter.receptions}</Avatar>}
                label="Receptions"
              />
            )}
          </div>
        </section>
        <section className={clsx(classes.segment, classes.map)}>
          <Map
            marginWrap="0"
            width="100%"
            height={isWidthUp("sm") ? "40vw" : "100%"}
            center={[frontmatter.longitude, frontmatter.latitude]}
            markers={markers}
            showStations={false}
            zoom={18}
          />
        </section>
      </Container>
    </main>
  );
};

PropertyPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  summary: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
  tags: PropTypes.arrayOf(PropTypes.string),
  images: PropTypes.arrayOf(PropTypes.object),
  frontmatter: PropTypes.object,
};

const PropertyPost = ({ data, location }): ReactElement => {
  const { markdownRemark: post } = data;
  const re = new RegExp("<p>", "g");

  const listHtmlArr = post.html.split(".,")[1]?.replace(re, "<li>").split(" ");
  const descriptionHtmlArr = post.html.split(".,")[0].split(" ");
  descriptionHtmlArr?.push("</p>");
  const descriptionHtml = descriptionHtmlArr?.join(" ");
  listHtmlArr?.unshift("<li>");
  const listHtml = listHtmlArr?.join(" ");
  const newHtml = descriptionHtml?.concat(listHtml)?.split(",,,,")[0];
  const rootUrl = "https://williamslynch.co.uk";

  return (
    <Layout pathname={location.pathname}>
      <PropertyPostTemplate
        content={newHtml}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        summary={post.frontmatter.summary}
        helmet={
          <Helmet titleTemplate="%s | Properties">
            <title>{`${post.frontmatter.title}`}</title>
            <meta name="description" content={`${post.frontmatter.summary}`} />
            <meta name="image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
            <meta name="og:image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
            <meta name="twitter:image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        price={post.frontmatter.price}
        title={post.frontmatter.addressSa1}
        images={post.frontmatter.images}
        frontmatter={post.frontmatter}
        filterOptions={location.state?.filterOptions}
      />
    </Layout>
  );
};

PropertyPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
  location: PropTypes.object,
};

export default PropertyPost;

export const pageQuery = graphql`
  query PropertyPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      excerpt(pruneLength: 400)
      id
      html
      fields {
        slug
      }
      frontmatter {
        virturaltour
        floorPlan
        tags
        id
        title
        templateKey
        # path
        # heading
        summary
        description
        # subheading
        address
        # addressNum
        addressSa1
        # addressSa2
        # addressTown
        # addressCity
        # addressCounty
        # addressCountry
        # addressPostcode
        bathrooms
        bedrooms
        date
        # date(formatString: "MMMM DD, YYYY")
        # dateInstructed
        # featuredpost
        garages
        gardens
        # hits
        images {
          relativePath
          childImageSharp {
            fluid(maxWidth: 2048, quality: 64) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        latitude
        leaseType
        longitude
        dateSTC
        otherrooms
        parkingSpaces
        # period
        # portfolio
        price
        pricetext
        poa
        propertyType
        receptions
        rentalperiod
        sold
        # specials
        # UO_LA
        # updated
        # date(formatString: "MMMM DD, YYYY")
        featuredimage {
          childImageSharp {
            fluid(maxWidth: 640, quality: 64) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
